import React, { useEffect, useState } from 'react';
import azureDevOpsService from './services/azureDevOpsService';

export default function KpiBugsByPerson() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchBugsByPerson() {
      setLoading(true);
      try {
        // Query WIQL pour récupérer les bugs créés par les membres spécifiques
        const wiql = `SELECT [System.Id], [System.Title], [System.AssignedTo], [System.State], [System.CreatedBy], [System.CreatedDate]
FROM WorkItems 
WHERE [System.TeamProject] = 'Fabrique' 
  AND [System.WorkItemType] = 'Bug' 
  AND [System.CreatedBy] IN (@me, 'Billal CHERIF <bcherif@chapsvision.com>', 'Amélie LEMAITRE <alemaitre@chapsvision.com>', 'Sami MECILI <smecili@chapsvision.com>', 'Rahma BOUKHRIS <rboukhris@chapsvision.com>', 'Amal BEN TAHER <abentaher@chapsvision.com>', 'Soufian ZEAMARI <szeamari@chapsvision.com>', 'Nabil MOUADDAB <nmouaddab.ext@chapsvision.com>', 'Nicolas CROQUELOIS <ncroquelois@chapsvision.com>', 'Florian MORINEAU <fmorineau@chapsvision.com>', 'Alexandre PEREYRA <apereyra@chapsvision.com>')
  AND [System.CreatedDate] > '2025-08-01T00:00:00.0000000' 
  AND [System.CreatedDate] < '2025-12-31T00:00:00.0000000'
ORDER BY [System.CreatedDate] DESC`;

        // Exécuter la requête WIQL
        const wiqlResponse = await azureDevOpsService.makeApiCall('/wit/wiql?api-version=7.0', {
          method: 'POST',
          body: JSON.stringify({ query: wiql })
        });

        const ids = (wiqlResponse.workItems || []).map(w => w.id).filter(Boolean);
        
        if (ids.length === 0) {
          setData([]);
          setLoading(false);
          return;
        }

        // Récupérer les détails des work items
        const chunkSize = 200;
        const fields = [
          'System.Id',
          'System.Title',
          'System.AssignedTo',
          'System.State',
          'System.CreatedBy',
          'System.CreatedDate'
        ];

        const allWorkItems = [];
        for (let i = 0; i < ids.length; i += chunkSize) {
          const chunk = ids.slice(i, i + chunkSize);
          const idsParam = chunk.join(',');
          const endpoint = `/wit/workitems?ids=${idsParam}&fields=${fields.join(',')}&api-version=7.0`;
          const res = await azureDevOpsService.makeApiCall(endpoint);
          if (res && res.value) {
            allWorkItems.push(...res.value);
          }
        }

        // Grouper par personne assignée (AssignedTo)
        const bugsByPerson = {};
        allWorkItems.forEach(item => {
          const assignedTo = item.fields['System.CreatedBy'];
          const personName = assignedTo ? assignedTo.displayName : 'Non assigné';
          
          if (!bugsByPerson[personName]) {
            bugsByPerson[personName] = 0;
          }
          bugsByPerson[personName]++;
        });

        // Convertir en tableau et trier par nombre de bugs décroissant
        const sortedData = Object.entries(bugsByPerson)
          .map(([person, count]) => ({
            person,
            count
          }))
          .sort((a, b) => b.count - a.count);

        setData(sortedData);
      } catch (error) {
        console.error('Erreur lors de la récupération des bugs par personne:', error);
        setData([]);
      } finally {
        setLoading(false);
      }
    }

    fetchBugsByPerson();
  }, []);

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-xl font-bold mb-4 text-gray-800">Bugs par Personne</h3>
      
      {loading && (
        <div className="text-center py-8">
          <p className="text-gray-500">Chargement...</p>
        </div>
      )}

      {!loading && data.length === 0 && (
        <div className="text-center py-8">
          <p className="text-gray-500">Aucune donnée disponible</p>
        </div>
      )}

      {!loading && data.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b-2 border-gray-300">
                <th className="text-left py-2 px-4 font-semibold text-gray-700">Personne</th>
                <th className="text-right py-2 px-4 font-semibold text-gray-700">Nombre de Bugs</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr 
                  key={index} 
                  className="border-b border-gray-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-gray-800">{row.person}</td>
                  <td className="py-3 px-4 text-right">
                    <span className="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full font-semibold">
                      {row.count}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="mt-4 text-xs text-gray-500">
        <p>Période: 01/08/2025 - 31/12/2025</p>
      </div>
    </div>
  );
}
